module.exports = __webpack_public_path__ + "static/media/video.b05219d0.svg";